// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-revision-material-header {
  position: relative;
  padding: 25px 0 5px;
  margin-bottom: 30px;
  color: #ffffff;
  background: #00a881;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.1607843137) !important;
}
.custom-revision-material-header form.top_header .css-2b097c-container .css-yk16xz-control,
.custom-revision-material-header form.top_header .css-2b097c-container .css-1pahdxg-control {
  background: hsla(0, 0%, 100%, 0.22);
  border-radius: 30px;
  border-color: hsla(0, 0%, 100%, 0.22);
  box-shadow: none;
}
.custom-revision-material-header form.top_header .css-2b097c-container .css-yk16xz-control .css-1uccc91-singleValue,
.custom-revision-material-header form.top_header .css-2b097c-container .css-yk16xz-control .css-1wa3eu0-placeholder,
.custom-revision-material-header form.top_header .css-2b097c-container .css-yk16xz-control .css-b8ldur-Input,
.custom-revision-material-header form.top_header .css-2b097c-container .css-1pahdxg-control .css-1uccc91-singleValue,
.custom-revision-material-header form.top_header .css-2b097c-container .css-1pahdxg-control .css-1wa3eu0-placeholder,
.custom-revision-material-header form.top_header .css-2b097c-container .css-1pahdxg-control .css-b8ldur-Input {
  color: #ffffff;
}
.custom-revision-material-header form.top_header .css-2b097c-container .css-yk16xz-control .css-6q0nyr-Svg,
.custom-revision-material-header form.top_header .css-2b097c-container .css-1pahdxg-control .css-6q0nyr-Svg {
  color: #ffffff;
}
.custom-revision-material-header form.top_header .css-2b097c-container .css-26l3qy-menu {
  color: #212529;
}
.custom-revision-material-header.chemistry {
  background: #0060ce;
}
.custom-revision-material-header.physics {
  background: #feaf55;
}
.custom-revision-material-header.botany {
  background: #3d8815;
}
.custom-revision-material-header.zoology {
  background: #c37800;
}
.custom-revision-material-header.maths {
  background: #707070;
}

.revision-materials-section .section-title {
  background: linear-gradient(180deg, #f30000 0%, #fdae1d 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.revision-materials-section .revision-material-cards .single-card {
  margin-bottom: 20px;
}
.revision-materials-section .revision-material-cards .single-card .card {
  color: #ffffff;
  height: 80px;
  border: 1px solid #a5a5a5;
  border-radius: 0.45rem;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0431372549);
  top: 0;
  cursor: pointer;
  transition: all 0.3s;
}
.revision-materials-section .revision-material-cards .single-card .card .title {
  font-size: 14px;
}
.revision-materials-section .revision-material-cards .single-card .card:hover {
  top: -6px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.revision-materials-section .revision-material-cards .single-card.shortnotes .card {
  background-image: linear-gradient(to top, #2b7270 0%, #a9e87c 100%);
}
.revision-materials-section .revision-material-cards .single-card.formula .card {
  background-image: linear-gradient(to top, #2c68d9 0%, #134297 100%);
}
.revision-materials-section .revision-material-cards .single-card.videos .card {
  background-image: linear-gradient(to top, #a4caec 0%, #505ad9 100%);
}
.revision-materials-section .revision-material-cards .single-card.constants .card {
  background-image: linear-gradient(to top, #f07752 0%, #dc517b 100%);
}
.revision-materials-section .revision-material-cards .single-card.shapes .card {
  background-image: linear-gradient(to bottom, #a9e87c 0%, #2b7270 100%);
}
.revision-materials-section .revision-material-cards .single-card.reactions .card {
  background-image: linear-gradient(to top, #f1c44f 0%, #f08d64 100%);
}
.revision-materials-section .revision-material-cards .single-card.numericals .card {
  background-image: linear-gradient(to top, #f0b1e3 0%, #816ebe 100%);
}
.revision-materials-section .revision-material-cards .single-card.exceptions .card {
  background-image: linear-gradient(to top, #b8222b 0%, #5a043d 100%);
}
.revision-materials-section .revision-material-cards .single-card.diagrams .card {
  background-image: linear-gradient(to top, #7579e4 0%, #f1b7c7 100%);
}
.revision-materials-section .revision-material-cards .single-card.namedreactions .card {
  background-image: linear-gradient(to top, #f1c44f 0%, #f08d64 100%);
}
.revision-materials-section .revision-material-cards .single-card.abbreviation .card {
  background-image: linear-gradient(to top, #a4caec 0%, #505ad9 100%);
}
.revision-materials-section .revision-material-cards .single-card.importantpoints .card {
  background-image: linear-gradient(to top, #f07752 0%, #dc517b 100%);
}
.revision-materials-section .revision-material-cards .single-card.formuladerviation .card {
  background-image: linear-gradient(to top, #f1c44f 0%, #f08d64 100%);
}
.revision-materials-section .revision-material-cards .single-card.graph .card {
  background-image: linear-gradient(to top, #f0b1e3 0%, #816ebe 100%);
}
.revision-materials-section .revision-material-cards .single-card.examples .card {
  background-image: linear-gradient(to top, #2b7270 0%, #a9e87c 100%);
}
.revision-materials-section .revision-material-cards .single-card.properties .card {
  background-image: linear-gradient(to top, #b8222b 0%, #5a043d 100%);
}
.revision-materials-section .revision-material-cards .single-card.scientiest .card {
  background-image: linear-gradient(to top, #7579e4 0%, #f1b7c7 100%);
}
.revision-materials-section .revision-material-cards .single-card.definition .card {
  background-image: linear-gradient(to top, #a4caec 0%, #505ad9 100%);
}
.revision-materials-section .revision-material-cards .single-card.differences .card {
  background-image: linear-gradient(to top, #f07752 0%, #dc517b 100%);
}
.revision-materials-section .revision-material-cards .single-card.experiment .card {
  background-image: linear-gradient(to top, #b8222b 0%, #5a043d 100%);
}
.revision-materials-section .revision-material-cards .single-card.chemicalcomposition .card {
  background-image: linear-gradient(to top, #134297 0%, #2c68d9 100%);
}
.revision-materials-section .revision-material-cards .single-card.reactionsmechanisms .card {
  background-image: linear-gradient(to top, #f0b1e3 0%, #816ebe 100%);
}
.revision-materials-section .revision-material-cards .single-card.tipsshortcuts .card {
  background-image: linear-gradient(to top, #134297 0%, #2c68d9 100%);
}

.custom-revision-materials .concept_cards .single_concept .lock-icon {
  display: none;
}
.custom-revision-materials .concept_cards .single_concept .icon-indicator {
  position: absolute;
  right: 0;
  bottom: 0;
}
.custom-revision-materials .concept_cards .single_concept .helpTags li i {
  cursor: pointer;
}
.custom-revision-materials .concept_cards .single_concept .card-body {
  overflow: hidden;
  position: relative;
  height: 96px;
  padding-top: 0.5rem !important;
  margin-bottom: 0.5rem;
}
.custom-revision-materials .concept_cards .single_concept.lock {
  position: relative;
  overflow: hidden;
}
.custom-revision-materials .concept_cards .single_concept.lock .lock-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-revision-materials .concept_cards .single_concept.lock .card-header,
.custom-revision-materials .concept_cards .single_concept.lock .card-body {
  color: transparent;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  filter: blur(2px);
}
.custom-revision-materials .concept_cards.singles-materials .single_concept .card-body {
  position: relative;
  height: 100%;
  padding-top: 0.5rem !important;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/all_custom_revision_materials/_custom_revision_materials.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,+DAAA;AACF;AAEI;;EAEE,mCAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;AAAN;AAEM;;;;;;EAGE,cAAA;AAGR;AADM;;EACE,cAAA;AAIR;AADI;EACE,cAAA;AAGN;AACE;EACE,mBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;;AAQE;EACE,6DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AALJ;AAQE;EACE,mBAAA;AANJ;AAQI;EACE,cAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,oDAAA;EACA,MAAA;EACA,eAAA;EACA,oBAAA;AANN;AAQM;EACE,eAAA;AANR;AASM;EACE,SAAA;EACA,qFAAA;AAPR;AAYI;EACE,mEAAA;AAVN;AAaI;EACE,mEAAA;AAXN;AAcI;EACE,mEAAA;AAZN;AAeI;EACE,mEAAA;AAbN;AAgBI;EACE,sEAAA;AAdN;AAiBI;EACE,mEAAA;AAfN;AAkBI;EACE,mEAAA;AAhBN;AAmBI;EACE,mEAAA;AAjBN;AAoBI;EACE,mEAAA;AAlBN;AAqBI;EACE,mEAAA;AAnBN;AAsBI;EACE,mEAAA;AApBN;AAuBI;EACE,mEAAA;AArBN;AAwBI;EACE,mEAAA;AAtBN;AAyBI;EACE,mEAAA;AAvBN;AA0BI;EACE,mEAAA;AAxBN;AA2BI;EACE,mEAAA;AAzBN;AA4BI;EACE,mEAAA;AA1BN;AA6BI;EACE,mEAAA;AA3BN;AA8BI;EACE,mEAAA;AA5BN;AA+BI;EACE,mEAAA;AA7BN;AAgCI;EACE,mEAAA;AA9BN;AAiCI;EACE,mEAAA;AA/BN;AAkCI;EACE,mEAAA;AAhCN;;AAwCM;EACE,aAAA;AArCR;AAuCM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AArCR;AAwCM;EACE,eAAA;AAtCR;AAyCM;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,gBAAA;AAvCR;AAyCQ;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EAOA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7CV;AA+CQ;;EAEE,kBAAA;EACA,uCAAA;EACA,iBAAA;AA7CV;AAkDI;EACE,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;AAhDN","sourcesContent":[".custom-revision-material-header {\n  position: relative;\n  padding: 25px 0 5px;\n  margin-bottom: 30px;\n  color: #ffffff;\n  background: #00a881;\n  box-shadow: 0px 3px 16px #00000029 !important;\n\n  form.top_header .css-2b097c-container {\n    .css-yk16xz-control,\n    .css-1pahdxg-control {\n      background: hsla(0, 0%, 100%, 0.22);\n      border-radius: 30px;\n      border-color: hsla(0, 0%, 100%, 0.22);\n      box-shadow: none;\n\n      .css-1uccc91-singleValue,\n      .css-1wa3eu0-placeholder,\n      .css-b8ldur-Input {\n        color: #ffffff;\n      }\n      .css-6q0nyr-Svg {\n        color: #ffffff;\n      }\n    }\n    .css-26l3qy-menu {\n      color: #212529;\n    }\n  }\n\n  &.chemistry {\n    background: #0060ce;\n  }\n\n  &.physics {\n    background: #feaf55;\n  }\n\n  &.botany {\n    background: #3d8815;\n  }\n\n  &.zoology {\n    background: #c37800;\n  }\n\n  &.maths {\n    background: #707070;\n  }\n}\n\n.revision-materials-section {\n  .section-title {\n    background: linear-gradient(180deg, #f30000 0%, #fdae1d 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n  .revision-material-cards .single-card {\n    margin-bottom: 20px;\n\n    .card {\n      color: #ffffff;\n      height: 80px;\n      border: 1px solid #a5a5a5;\n      border-radius: 0.45rem;\n      box-shadow: 0px 3px 20px #0000000b;\n      top: 0;\n      cursor: pointer;\n      transition: all 0.3s;\n\n      .title {\n        font-size: 14px;\n      }\n\n      &:hover {\n        top: -6px;\n        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n          0 10px 10px -5px rgba(0, 0, 0, 0.04);\n      }\n    }\n\n    &.shortnotes .card {\n      background-image: linear-gradient(to top, #2b7270 0%, #a9e87c 100%);\n    }\n\n    &.formula .card {\n      background-image: linear-gradient(to top, #2c68d9 0%, #134297 100%);\n    }\n\n    &.videos .card {\n      background-image: linear-gradient(to top, #a4caec 0%, #505ad9 100%);\n    }\n\n    &.constants .card {\n      background-image: linear-gradient(to top, #f07752 0%, #dc517b 100%);\n    }\n\n    &.shapes .card {\n      background-image: linear-gradient(to bottom, #a9e87c 0%, #2b7270 100%);\n    }\n\n    &.reactions .card {\n      background-image: linear-gradient(to top, #f1c44f 0%, #f08d64 100%);\n    }\n\n    &.numericals .card {\n      background-image: linear-gradient(to top, #f0b1e3 0%, #816ebe 100%);\n    }\n\n    &.exceptions .card {\n      background-image: linear-gradient(to top, #b8222b 0%, #5a043d 100%);\n    }\n\n    &.diagrams .card {\n      background-image: linear-gradient(to top, #7579e4 0%, #f1b7c7 100%);\n    }\n\n    &.namedreactions .card {\n      background-image: linear-gradient(to top, #f1c44f 0%, #f08d64 100%);\n    }\n\n    &.abbreviation .card {\n      background-image: linear-gradient(to top, #a4caec 0%, #505ad9 100%);\n    }\n\n    &.importantpoints .card {\n      background-image: linear-gradient(to top, #f07752 0%, #dc517b 100%);\n    }\n\n    &.formuladerviation .card {\n      background-image: linear-gradient(to top, #f1c44f 0%, #f08d64 100%);\n    }\n\n    &.graph .card {\n      background-image: linear-gradient(to top, #f0b1e3 0%, #816ebe 100%);\n    }\n\n    &.examples .card {\n      background-image: linear-gradient(to top, #2b7270 0%, #a9e87c 100%);\n    }\n\n    &.properties .card {\n      background-image: linear-gradient(to top, #b8222b 0%, #5a043d 100%);\n    }\n\n    &.scientiest .card {\n      background-image: linear-gradient(to top, #7579e4 0%, #f1b7c7 100%);\n    }\n\n    &.definition .card {\n      background-image: linear-gradient(to top, #a4caec 0%, #505ad9 100%);\n    }\n\n    &.differences .card {\n      background-image: linear-gradient(to top, #f07752 0%, #dc517b 100%);\n    }\n\n    &.experiment .card {\n      background-image: linear-gradient(to top, #b8222b 0%, #5a043d 100%);\n    }\n\n    &.chemicalcomposition .card {\n      background-image: linear-gradient(to top, #134297 0%, #2c68d9 100%);\n    }\n\n    &.reactionsmechanisms .card {\n      background-image: linear-gradient(to top, #f0b1e3 0%, #816ebe 100%);\n    }\n\n    &.tipsshortcuts .card {\n      background-image: linear-gradient(to top, #134297 0%, #2c68d9 100%);\n    }\n  }\n}\n\n.custom-revision-materials {\n  .concept_cards {\n    .single_concept {\n      .lock-icon {\n        display: none;\n      }\n      .icon-indicator {\n        position: absolute;\n        right: 0;\n        bottom: 0;\n      }\n\n      .helpTags li i {\n        cursor: pointer;\n      }\n\n      .card-body {\n        overflow: hidden;\n        position: relative;\n        height: 96px;\n        padding-top: 0.5rem !important;\n        margin-bottom: 0.5rem;\n      }\n      &.lock {\n        position: relative;\n        overflow: hidden;\n\n        .lock-icon {\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          right: 0;\n          left: 0;\n          z-index: 1;\n          margin: auto;\n          // font-size: 1.5rem;\n          // width: 40px;\n          // height: 40px;\n          // border-radius: 50%;\n          // color: #000000;\n          // background: #ff9800;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        .card-header,\n        .card-body {\n          color: transparent;\n          text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n          filter: blur(2px);\n        }\n      }\n    }\n\n    &.singles-materials .single_concept .card-body {\n      position: relative;\n      height: 100%;\n      padding-top: 0.5rem !important;\n      margin-bottom: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
